<template>
    <v-select
        v-model="selectedCountry"
        :options="countriesList"
        :clearable="false"
        :searchable="true"
        :placeholder="$t('school_form_select_country')"
        class="country-select no-badge"
        label="name"
        id="status"
    >
        <template #no-options>{{ $t('sorry_no_natching_options') }}</template>
    </v-select>
</template>

<script>
import datalist from '@/mixins/datalist'

export default {
    mixins: [datalist],

    watch: {
        selectedCountry(country) {
            this.$emit('selected', country)
        }
    },

    data() {
        return {
            selectedCountry: null
        }
    }
}
</script>

<style lang="scss">
.country-select {
    .vs__dropdown-toggle {
        height: 40px;
        padding: 0 10.5px;

        .vs__selected {
            height: 100%;
            margin: 0;
            padding: 0;
            font-size: 14px;
            color: #495057;
        }

        .vs__actions {
            padding: 0;
        }

        .vs__search,
        .vs__search:focus {
            font-size: 14px;
            margin: 0;
            padding: 0;
        }

        input {
            height: 100%;
            margin: 0;
            padding: 0;
            font-size: 14px;
            color: #495057;

            &::placeholder {
                color: #757575;
            }
        }
    }
}
</style>
